<script lang="ts">
import type { RouteLocationRaw } from '#vue-router';

export type BreadcrumbItemType = {
  label: string;
  to?: RouteLocationRaw;
};
</script>

<script lang="ts" setup>
const props = defineProps<{
  items: BreadcrumbItemType[];
}>();

const { t } = useI18n();

useSchemaOrg([
  defineBreadcrumb({
    itemListElement: [
      { name: t('home'), item: '/' },
      ...props.items.map((item) => ({
        name: item.label,
        item: item.to,
      })),
    ],
  }),
]);
</script>

<template>
  <div class="baseBreadcrumb">
    <NuxtLink to="/" class="baseBreadcrumb__label baseBreadcrumb__label_link">
      {{ t('home') }}
    </NuxtLink>
    <TransitionGroup name="fade">
      <div v-for="(item, index) in items" :key="`${index}-${item.label}`" class="baseBreadcrumb__item">
        <SvgoSimpleCaret :font-controlled="false" class="baseBreadcrumb__icon" />
        <NuxtLink v-if="item.to" :to="item.to" class="baseBreadcrumb__label baseBreadcrumb__label_link">
          {{ item.label }}
        </NuxtLink>
        <span v-else class="baseBreadcrumb__label">
          {{ item.label }}
        </span>
      </div>
    </TransitionGroup>
  </div>
</template>

<i18n>
ru:
  home: Главная

en:
  home: Home
</i18n>

<style lang="scss">
.baseBreadcrumb {
  $self: &;

  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 0;

  &__item {
    display: flex;
    align-items: center;
    gap: 8px;

    &:last-child {
      overflow: hidden;

      #{$self}__label {
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }

  &__icon {
    color: #878787;
    width: 16px;
    height: 16px;
  }

  &__label {
    font-size: 20px;
    line-height: 28px;
    letter-spacing: 0.2px;
    color: #878787;
    white-space: nowrap;

    @include mq('md') {
      font-size: 18px;
      line-height: 24px;
    }

    @include mq('sm') {
      font-size: 16px;
    }

    &_link {
      transition: color 0.3s ease;

      &:hover {
        color: #121212;
      }
    }
  }
}
</style>
